import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { addIcons } from 'ionicons';
import {
  peopleOutline,
  homeOutline,
  calendarOutline,
  ellipsisHorizontalOutline,
  chatbubblesOutline,
  trophyOutline
} from 'ionicons/icons';

// Register all icons globally
addIcons({ homeOutline, peopleOutline, calendarOutline, ellipsisHorizontalOutline, chatbubblesOutline, trophyOutline });

// Configure Ionicons to load SVGs from the correct path
(window as any).Ionicons = (window as any).Ionicons || {};
(window as any).Ionicons.setAssetPath = '/svg/';

console.log('🚀 Starting bootstrap process...');
bootstrapApplication(AppComponent, appConfig)
  .then(() => console.log('✅ Bootstrap successful'))
  .catch((err) => {
    console.error('❌ Bootstrap failed:', err);
  });
